import { render, staticRenderFns } from "./defective-record.vue?vue&type=template&id=6f849e3c&scoped=true&"
import script from "./defective-record.vue?vue&type=script&lang=js&"
export * from "./defective-record.vue?vue&type=script&lang=js&"
import style0 from "./defective-record.vue?vue&type=style&index=0&id=6f849e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f849e3c",
  null
  
)

export default component.exports